import { useEffect, useRef } from 'react';

import displayControls from '../../../helpers/displayControls';

import { Player, PlayerMappedControls } from './../../../types';

const useDisplayControls = (player: Player | null, controls?: PlayerMappedControls[]) => {
  const currentVideo = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const canDisplayControls = player && controls && currentVideo;

    canDisplayControls && displayControls(controls!, currentVideo.current!);
  }, [controls, player, currentVideo?.current]);

  return currentVideo;
};

export default useDisplayControls;
